var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DynamicFeaturesPage',{attrs:{"feature":"dna-budgets-prototype"},scopedSlots:_vm._u([{key:"enabled",fn:function(){return [_c('DNABudgets')]},proxy:true},{key:"disabled",fn:function(){return [_c('Budgets')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }